import React, { useEffect } from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light-border.css';
import { ITableFilterItem } from '../../../../../resources/interfaces';
import { MdOutlineFilterAlt } from "react-icons/md";
import useModal from '../../../../../hooks/modalHook';
import useLayoutHook from '../../../../../hooks/layoutHook';

interface ITableFilter {
  content: JSX.Element | React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  onClickOutside?: () => void;
  openFilter?: boolean;
  onFilterChange?: (filterState: boolean) => void;
  selectedFilters?: ITableFilterItem[];
  onRemoveFilter?: (filter: ITableFilterItem, index: number) => void;
}

const TableFilter = ({ content, onClick, onClickOutside, openFilter = false, onFilterChange, selectedFilters, onRemoveFilter }: ITableFilter) => {
  const [open, setOpen] = React.useState<boolean>(openFilter);
  const { updateModalStates, showModal, closeModal, ModalComponent } = useModal();
  const { screenWidth } = useLayoutHook();

  useEffect(() => {
    if (open !== openFilter) {
      setOpen(openFilter);
    }
  }, [openFilter]);
  const handleOpenFilters = () => {
    updateModalStates({
      show: true,
      title: 'Filters',
      size: 'md',
      children: <div className="w-full">{content}</div>
    });
};

  return (
    <>
    {screenWidth <= 550  ?  
     <button
         
          onClick={handleOpenFilters}
          className="border flex !text-sm justify-center items-center border-primary-main hover:bg-primary-main w-fit rounded-full px-4 !py-2 dark:text-darkBg-mainText">
          <MdOutlineFilterAlt size={18} className="dark:text-darkBg-mainText"/>
          Filters
        </button>
 
      : <div className="w-full flex dark:bg-darkBg">
      <Tippy
        content={<div className="w-full">{content}</div>}
        visible={open}
        interactive
        onClickOutside={() => {
          if (onClickOutside) {
            onClickOutside();
          }
          setOpen(false);
          onFilterChange?.(false);
        }}
        placement="bottom-start"
        className="w-full !border-none"
        maxWidth="1024px"
        theme="light-border"
        appendTo={'parent'}>
        <button
          type="submit"
          onClick={(event: React.MouseEvent<HTMLElement>) => {
            event.stopPropagation();
            if (onClick) {
              onClick(event);
            }

            if (onFilterChange) {
              onFilterChange?.(!open);
            } else {
              setOpen(!open);
            }

          }}
          className="border flex !text-sm justify-center items-center border-primary-main hover:bg-primary-main w-fit rounded-full px-4 !py-2 dark:text-darkBg-mainText">
          <MdOutlineFilterAlt size={18} className="dark:text-darkBg-mainText"/>
          Filters
        </button>
      </Tippy>

    </div>}
    <ModalComponent/>
    </>
  );
};

export default TableFilter;
